// extracted by mini-css-extract-plugin
module.exports = {"nameBlock":"styles_nameBlock__hIdbf","img":"styles_img__32uC7"};